// Gotify server configuration.
// Follows the same hostname-based runtime pattern as auth0.config.ts —
// no environment.ts files are used in this project.

import { getEnvUrl } from './environment.service';
//
// Hay un Gotify POR TENANT (`<tenant>-gotify`), expuesto para todos en el mismo host
// `gotify.shared.n.synapseguard.com`: quien decide a cuál se llega es APISIX, por la
// organización del token de Auth0.
//
// ⚠️ PENDIENTE DE SG-2, y no se puede resolver desde aquí: `gotifyClientToken` sale del
// ConfigMap del frontend, y el frontend es UNO para todos los clientes — mientras que el
// token de cliente de Gotify es de UN tenant (secreto `<tenant>-gotify-token`, §8.1). O
// sea que hoy solo puede haber un valor, y con él las notificaciones funcionarían para un
// cliente y para el resto no. Sacarlo del ConfigMap exige una vía por usuario (que la API
// lo devuelva tras el login, resolviéndolo por la organización del token) que todavía no
// existe. Hasta entonces, esta clave se queda vacía y el WebSocket no se abre.
//
// After deploying Gotify:
//   1. Log in as admin at the Gotify URL of the environment (`gotifyServerUrl` in
//      runtime-env.js — no la escribas aquí)
//   2. Go to Clients → "Add Client" (e.g. name: "synapseguard-angular")
//   3. Copy the generated client token
//   4. Replace REPLACE_WITH_GOTIFY_CLIENT_TOKEN below
//
// The client token grants read-only access to the notification stream.
// It is NOT an admin credential — it is safe to ship in the frontend bundle.

export interface GotifyConfig {
  /** Base HTTPS URL of the Gotify server */
  serverUrl: string;
  /** Gotify client token — created in the Gotify Admin UI under Clients */
  clientToken: string;
}

export const getGotifyConfig = (): GotifyConfig => {
  // Both values are read from runtime-env.js (generated by entrypoint.sh from pod env vars).
  //
  // ⚠️ El fallback va por `getEnvUrl`, que es la MISMA vía que el resto de la app. Esta
  // función llegó a tener su propio literal, así que había dos respuestas para la misma
  // pregunta y una de las dos siempre se quedaba en un clúster retirado. Con una sola vía
  // no pueden divergir: hoy el host es `gotify.shared.n.synapseguard.com`.
  //
  // El `clientToken` autoriza a LEER el stream de Gotify, y NO basta: la conexión pasa
  // antes por APISIX, que exige el Bearer de Auth0 (ver `GotifyService`).
  const raw = (globalThis as unknown as Window).__env;
  const serverUrl = getEnvUrl('gotifyServerUrl');
  const clientToken = raw?.gotifyClientToken ?? '';

  return { serverUrl, clientToken };
};
